import { render, staticRenderFns } from "./CircleSvg.vue?vue&type=template&id=087be4bd"
import script from "./CircleSvg.vue?vue&type=script&lang=js"
export * from "./CircleSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('087be4bd')) {
      api.createRecord('087be4bd', component.options)
    } else {
      api.reload('087be4bd', component.options)
    }
    module.hot.accept("./CircleSvg.vue?vue&type=template&id=087be4bd", function () {
      api.rerender('087be4bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Visualisations/CircleSvg.vue"
export default component.exports